import { useEffect, useState } from "react";
import { Button, Select } from "antd";
import Main from "../../components/layout/Main";
import TumbnailImage from "../../assets/images/poadcasts-image.jpg";
import ClockImage from "../../assets/images/clock-image.svg";
import ArrowDownImage from "../../assets/images/arrow-down-image.svg";
import PoadcastcenterImage from "../../assets/images/POADCAST-CENTER-IMAGE.svg";
import { useNavigate } from "react-router";
import { usePodcast } from "../../context/PodcastContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import {
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  getAudioDuration,
  isScrollAtBottom,
} from "../../helper/functions";

const PodcastsIndex = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [expandedYears, setExpandedYears] = useState([]);
  const { loadPodCasts } = usePodcast();
  const { globalSearch } = useGlobalSearch();
  const [podcasts, setPodcasts] = useState([]);
  const [podcastCategories, setPodcastCategories] = useState(["All"]);
  // Pagination States
  const [page, setPage] = useState(DEFAULT_PAGE);
  const limit = DEFAULT_LIMIT;
  const [hasMore, setHasMore] = useState(true);
  // const [years, setYears] = useState(
  //   Array.from({ length: 11 }, (_, i) => new Date().getFullYear() - i)
  // );

  const [years, setYears] = useState([new Date().getFullYear()]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [params, setParams] = useState({ page, limit });
  const Navigate = useNavigate();
  const [durations, setDurations] = useState({});

  // -------------- Get podcast url ---------------

  const filteredPodcasts =
    activeCategory === "All"
      ? podcasts
      : podcasts.filter((p) => p.category === activeCategory);

  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  // ------------- handlers ------------

  const fetchPodcasts = async () => {
    try {
      const response = await loadPodCasts(params);
      setYears(response.data.podcastYears);
      // First get all keys
      const keys = Object.keys(response.data.all);
      setPodcastCategories((prev) => {
        const formatted = keys.map(
          (k) => k.charAt(0).toUpperCase() + k.slice(1)
        );
        const all = [...prev, ...formatted];
        return [...new Set(all)];
      });

      // STEP 1: convert object → array (same as before)
      const allItems = Object.keys(response.data.all).flatMap((categoryKey) => {
        return response.data.all[categoryKey].map((item) => ({
          ...item,
          category: categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1),
          year: new Date(item.publishDate).getFullYear(),
        }));
      });

      // STEP 2: fetch duration for each podcast
      // const podcastsWithDuration = await Promise.all(
      //   allItems.map(async (pod) => {
      //     try {
      //       const duration = pod.audioUrl
      //         ? await getAudioDuration(pod.audioUrl)
      //         : 0;

      //       return {
      //         title: pod.title,
      //         player: pod.author,
      //         audioUrl: pod.audioUrl,
      //         language: pod.language,
      //         status: pod.status,
      //         imageUrl: pod.coverImageUrl,
      //         comments: pod.comments,
      //         likes: pod.likes,
      //         podcastId: pod.podcastId,
      //         description: pod.description,
      //         category: pod.category,
      //         year: pod.year,
      //         _id: pod._id,
      //         views: `${duration || 0}`, // safe fallback
      //       };
      //     } catch (err) {
      //       console.error("duration error for", pod.audioUrl, err);

      //       // agar duration fail ho jaye, baaki data to rakho
      //       return {
      //         title: pod.title,
      //         player: pod.author,
      //         audioUrl: pod.audioUrl,
      //         language: pod.language,
      //         status: pod.status,
      //         imageUrl: pod.coverImageUrl,
      //         comments: pod.comments,
      //         likes: pod.likes,
      //         podcastId: pod.podcastId,
      //         description: pod.description,
      //         category: pod.category,
      //         year: pod.year,
      //         _id: pod._id,
      //         views: "0", // fallback
      //       };
      //     }
      //   })
      // );

      // STEP 3: Set to state
      setPodcasts(allItems);
    } catch (error) {
      console.log("error -->", error);
    }
  };

  // ---------- use effect ------------
  useEffect(() => {
    fetchPodcasts();
  }, [params]);

  useEffect(() => {
    setParams((prev) => {
      return {
        ...prev,
        search: globalSearch,
        year: selectedYear,
      };
    });
  }, [globalSearch, selectedYear]);

  useEffect(() => {
    podcasts.forEach((item) => {
      if (item.audioUrl && !durations[item.audioUrl]) {
        getAudioDuration(item.audioUrl).then((d) => {
          setDurations((prev) => ({
            ...prev,
            [item.audioUrl]: d,
          }));
        });
      }
    });
  }, [podcasts]);

  return (
    <Main>
      <div className="section-main">
        <div className="podcast-page podcast-main-page">
          <div className="orange-header">Podcasts</div>

          <div className="game-modes-filter" style={{ marginBottom: 20 }}>
            {podcastCategories.map((mode) => (
              <Button
                key={mode}
                type={activeCategory === mode ? "primary" : "default"}
                onClick={() => {
                  setActiveCategory(mode);
                  setExpandedYears([]);
                }}
                className="mode-filter-btn"
              >
                {mode}
              </Button>
            ))}
          </div>
          <section className="for-upcoming-tumanents">
            <div className="podcast-year-view-tab">
              {/* <div className="orange-header">{selectedYear}</div> */}
              <div className="year-filter">
                <Select
                  placeholder="Select Year"
                  value={selectedYear}
                  onChange={(value) => setSelectedYear(value)}
                  style={{ width: 150 }}
                >
                  {years?.map((yr) => (
                    <Select.Option key={yr} value={yr}>
                      {yr}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              {filteredPodcasts.length > 0 && (
                <div
                  className="orange-header"
                  onClick={() => Navigate(`/podcasts/${selectedYear}`)}
                >
                  View All
                </div>
              )}
            </div>

            <div className="">
              <div className="for-feature-grid-main">
                {filteredPodcasts && filteredPodcasts?.length > 0 ? (
                  filteredPodcasts?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="for-live-video-grid-inner"
                        onClick={() =>
                          Navigate(`/podcasts/${item.year}/${item._id}`)
                        }
                      >
                        <div className="for-live-video-grid-inner-image">
                          <img
                            src={item.coverImageUrl || TumbnailImage}
                            alt="thumbnail"
                          />
                          <h5>
                            <img src={ClockImage} alt="clock" />{" "}
                            {durations[item.audioUrl] || "Loading..."}
                          </h5>
                          <div className="center-image-podcasts">
                            <img
                              src={PoadcastcenterImage}
                              alt="podcast-center"
                            />
                          </div>
                        </div>

                        <div className="for-live-video-grid-footer">
                          <div className="for-player-text">
                            <h5>{item.title}</h5>
                            <p>{item.author}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No data available for this year</p>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </Main>
  );
};

export default PodcastsIndex;
